module.exports = __webpack_public_path__ + "1cedc5c5b6c190bcad9de9aee679bc84.MP3";